<template lang="pug" src="./instagram-grid.pug"></template>

<script>
import api from '../../../shared/api/api'
import axios from 'axios'

export default {
  data () {
    return {
      instagram: null
    }
  },
  async created () {
    try {
      const res = await axios.get(`${api}/rg-instagram/v1/get-photos`)
      this.instagram = res.data
    } catch (error) {
      console.error(error)
    }
  }
}
</script>

<style lang='sass' src='./instagram-grid.sass'></style>



// WEBPACK FOOTER //
// instagram-grid.vue?6e645cd1